import { render, staticRenderFns } from "./WebServicesSettingsView.vue?vue&type=template&id=05328866&scoped=true"
import script from "./WebServicesSettingsView.ts?vue&type=script&lang=ts&external"
export * from "./WebServicesSettingsView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05328866",
  null
  
)

export default component.exports